/** First-party cookies shared across rehub.studio subdomains. */

export const CONSENT_COOKIE = 'rehub_consent';
export const ATTRIBUTION_COOKIE = 'rehub_attr';

/** Six months. Visitors can change or withdraw the choice at any time. */
export const CONSENT_MAX_AGE_SECONDS = 60 * 60 * 24 * 183;

/** Thirteen months, matching acquisition reporting retention. */
export const ATTRIBUTION_MAX_AGE_SECONDS = 60 * 60 * 24 * 395;

export const CLICK_ID_RETENTION_MS = 90 * 24 * 60 * 60 * 1000;
export const ATTRIBUTION_RETENTION_MS = 395 * 24 * 60 * 60 * 1000;

export function sharedCookieDomain(hostname: string): '.rehub.studio' | null {
  const host = hostname.trim().toLowerCase().replace(/\.$/, '');
  if (host === 'rehub.studio' || host.endsWith('.rehub.studio')) return '.rehub.studio';
  return null;
}

export function serializeCookie(
  name: string,
  value: string,
  options: { domain: '.rehub.studio' | null; maxAgeSeconds: number; secure?: boolean },
): string {
  const encoded = encodeURIComponent(value);
  const parts = [
    `${name}=${encoded}`,
    'Path=/',
    `Max-Age=${options.maxAgeSeconds}`,
    'SameSite=Lax',
  ];
  if (options.domain) parts.push(`Domain=${options.domain}`);
  if (options.secure !== false) parts.push('Secure');
  return parts.join('; ');
}

export function readCookie(cookieHeader: string, name: string): string | null {
  const parts = cookieHeader.split(';');
  const prefix = `${name}=`;
  for (const part of parts) {
    const trimmed = part.trim();
    if (!trimmed.startsWith(prefix)) continue;
    try {
      return decodeURIComponent(trimmed.slice(prefix.length));
    } catch {
      return null;
    }
  }
  return null;
}
